import { Component, Input, OnInit } from '@angular/core';
import { ValidationsService } from 'src/app/services/validations.service';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
})
export class ErrorsComponent implements OnInit {
  constructor() {}

  @Input() errors: {
    min?: {
      min: any;
      actual?: any;
    };
    required: boolean;
    pattern?: {
      requiredPattern: any;
      actualValue?: any;
    };
  };

  @Input() showErrors: boolean = true;

  ngOnInit(): void {}

  get showLetterAndNumberError(): boolean {
    return this.errors?.pattern?.requiredPattern === ValidationsService.lettersAndNumbersPattern;
  }
}
